import HistoryEntryActor from "components/Run/elements/HistoryEntryActor";

type HistoryEntryUsernameProps = {
  username: string | null;
};

const HistoryEntryUsername = ({ username }: HistoryEntryUsernameProps) => {
  if (!username) {
    return null;
  }

  return (
    <>
      by <HistoryEntryActor actor={username} />
    </>
  );
};

export default HistoryEntryUsername;
